const depositPercent = 0.3 // 30%
const remainPercent = 1 - depositPercent

export { depositPercent, remainPercent }